import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [businessUnit, setBusinessUnit] = useState(null);
  const [loading, setLoading] = useState(true);

  // Initialize auth from session
  useEffect(() => {
    const rbacSessionStr = sessionStorage.getItem('rbac_session');
    if (rbacSessionStr) {
      try {
        const rbacSession = JSON.parse(rbacSessionStr);
        if (rbacSession.token) {
          // Decode JWT to get user info
          const payload = JSON.parse(atob(rbacSession.token.split('.')[1]));
          const actualUserId = payload.user_id || payload.id || payload.admin_id || payload.role_id;
          const userData = {
            id: actualUserId,
            role_id: payload.role_id || actualUserId,
            username: payload.username,
            role_name: payload.role_name,
            email: payload.email,
            client_id: rbacSession.client_id,
            business_unit_id: rbacSession.business_unit_id,
            headquarters_id: rbacSession.headquarters_id,
            token: rbacSession.token
          };
          setUser(userData);
          setBusinessUnit({
            id: rbacSession.business_unit_id,
            headquarters_id: rbacSession.headquarters_id,
            client_id: rbacSession.client_id
          });
          setIsAuthenticated(true);
        }
      } catch (e) {
        console.error('JWT decode failed:', e);
        setIsAuthenticated(false);
      }
    }
    setLoading(false);
  }, []);

  const logout = () => {
    sessionStorage.removeItem('rbac_session');
    setUser(null);
    setBusinessUnit(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      setUser, 
      logout, 
      isAuthenticated, 
      businessUnit,
      setBusinessUnit,
      loading 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
